<template>
<div class="chapter">
<div class="inner_page">
<p class="br"> </p><p class="br"> </p><p class="br"> </p><p class="br"> </p><p class="br"> </p><p class="acl">Para mis padres,</p><p class="br"> </p><p class="acl">Everardo y Severa Casares</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Brownsville_adca-1.vue?dcc8dd22